import { render, staticRenderFns } from "./TaskReportsForm.vue?vue&type=template&id=05cb66c8&scoped=true&lang=pug"
import script from "./TaskReportsForm.vue?vue&type=script&lang=js"
export * from "./TaskReportsForm.vue?vue&type=script&lang=js"
import style0 from "./TaskReportsForm.vue?vue&type=style&index=0&id=05cb66c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cb66c8",
  null
  
)

export default component.exports